import mobileToggle from './mobileToggle';

const init = (): void => {
  mobileToggle();
};

export default { init };
